function initKitPinatas() {
    const money = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', maximumFractionDigits: 0 });

    const kits = {
        kit1: { id: 'kit1', label: 'Kit 1', name: 'Diversión Creativa', price: 1099 },
        kit2: { id: 'kit2', label: 'Kit 2', name: 'Mini Exploradores', price: 1599 },
        kit3: { id: 'kit3', label: 'Kit 3', name: 'Pequeños Ingenieros', price: 1999 },
    };

    // Products will be injected via window.kitProducts array from Liquid
    const products = window.kitProducts || [];
    
    // Pagination state
    let currentPage = 1;
    const itemsPerPage = 12;
    const totalPages = Math.ceil(products.length / itemsPerPage);

    const selected = [];
    let selectedKit = null;
    let previousCartState = null;
    let isRestoringCart = false;

    // Fetch initial cart state
    fetch(window.Shopify.routes.root + 'cart.js')
        .then(r => r.json())
        .then(cart => previousCartState = cart);

    const els = {
        box: document.querySelector('.builder-box'),
        slots: document.getElementById('boxSlots'),
        count: document.getElementById('boxCount'),
        total: document.getElementById('boxTotal'),
        budget: document.getElementById('boxBudget'),
        cta: document.getElementById('boxCta'),
        note: document.getElementById('boxNote'),
        grid: document.getElementById('productsGrid'),
    };

    if (!els.slots || !els.grid) return;

    function getTotal() {
        return selected.reduce((sum, item) => sum + item.price, 0);
    }

    function setKit(kitId) {
        selectedKit = kits[kitId] || null;

        document.querySelectorAll('[data-kit]').forEach((card) => {
            const isActive = selectedKit && card.getAttribute('data-kit') === selectedKit.id;
            card.style.outline = isActive ? '3px solid rgba(139, 133, 212, 0.45)' : 'none';
            card.style.outlineOffset = isActive ? '4px' : '0';
        });

        if (!selectedKit) {
            els.budget.textContent = '';
            return;
        }

        const diff = selectedKit.price - getTotal();
        if (diff >= 0) {
            els.budget.textContent = `Presupuesto ${selectedKit.label}: ${money.format(selectedKit.price)} · Te faltan ${money.format(diff)} para igualarlo`;
        } else {
            els.budget.textContent = `Presupuesto ${selectedKit.label}: ${money.format(selectedKit.price)} · Te pasaste por ${money.format(Math.abs(diff))}`;
        }
    }

    function addProduct(productId) {
        if (selected.length >= 5) {
            if (els.box) {
                els.box.classList.remove('pulse');
                void els.box.offsetWidth;
                els.box.classList.add('pulse');
            }
            return;
        }
        if (selected.some((p) => p.id === productId)) return;

        const product = products.find((p) => p.id === productId);
        if (!product) return;

        selected.push(product);
        render();
    }

    function removeAt(index) {
        if (index < 0 || index >= selected.length) return;
        selected.splice(index, 1);
        render();
    }

    window.removeKitProduct = removeAt; // expose to window for onclick

    function renderSlots() {
        els.slots.innerHTML = '';
        for (let i = 0; i < 5; i++) {
            const slotBtn = document.createElement('button');
            slotBtn.type = 'button';
            slotBtn.className = 'slot';
            slotBtn.setAttribute('aria-label', selected[i] ? `Regalo ${i + 1}: ${selected[i].name}` : `Spot ${i + 1} vacío`);

            const item = selected[i];
            if (!item) {
                const n = document.createElement('div');
                n.className = 'n';
                n.textContent = `${i + 1}`;
                slotBtn.appendChild(n);
            } else {
                const img = document.createElement('img');
                img.src = item.img;
                img.alt = '';
                img.loading = 'lazy';
                slotBtn.appendChild(img);

                const remove = document.createElement('div');
                remove.className = 'remove';
                remove.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>';
                slotBtn.appendChild(remove);

                slotBtn.addEventListener('click', () => removeAt(i));
            }

            els.slots.appendChild(slotBtn);
        }
    }

    function renderProducts() {
        els.grid.innerHTML = '';
        
        const start = (currentPage - 1) * itemsPerPage;
        const end = start + itemsPerPage;
        const pageProducts = products.slice(start, end);

        pageProducts.forEach((p) => {
            const card = document.createElement('article');
            card.className = 'pk-card';
            card.innerHTML = `
                <div class="pk-media"><img src="${p.img}" alt="" loading="lazy"></div>
                <div class="pk-body">
                    <div class="pk-title">${p.name}</div>
                    <div class="pk-price">
                        <div class="amount">${money.format(p.price).replace('MXN', '').trim()}</div>
                        <div class="currency">MXN</div>
                    </div>
                    <button class="pk-btn" type="button">Agregar a la caja</button>
                </div>
            `;

            const btn = card.querySelector('.pk-btn');
            const isSelected = selected.some((s) => s.id === p.id);
            const isFull = selected.length >= 5;
            btn.disabled = isSelected || isFull;
            btn.textContent = isSelected ? 'Agregado' : (isFull ? 'Caja llena' : 'Agregar a la caja');

            btn.addEventListener('click', () => addProduct(p.id));
            els.grid.appendChild(card);
        });
        
        renderPagination();
    }
    
    function renderPagination() {
        let pagContainer = document.getElementById('kitPagination');
        if (!pagContainer) {
            pagContainer = document.createElement('div');
            pagContainer.id = 'kitPagination';
            pagContainer.className = 'kit-pagination';
            els.grid.parentNode.appendChild(pagContainer);
        }
        
        pagContainer.innerHTML = '';
        if (totalPages <= 1) return;

        const prevBtn = document.createElement('button');
        prevBtn.className = 'pag-btn';
        prevBtn.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>';
        prevBtn.disabled = currentPage === 1;
        prevBtn.onclick = () => { 
            if(currentPage > 1) { 
                currentPage--; 
                renderProducts(); 
                document.getElementById('arma-tu-kit')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            } 
        };
        pagContainer.appendChild(prevBtn);

        // Calculate sliding window of pages
        let startPage = Math.max(1, currentPage - 2);
        let endPage = Math.min(totalPages, startPage + 4);
        if (endPage - startPage < 4) {
            startPage = Math.max(1, endPage - 4);
        }

        if (startPage > 1) {
            const firstBtn = document.createElement('button');
            firstBtn.className = 'pag-btn';
            firstBtn.textContent = '1';
            firstBtn.onclick = () => { currentPage = 1; renderProducts(); document.getElementById('arma-tu-kit')?.scrollIntoView({ behavior: 'smooth', block: 'start' }); };
            pagContainer.appendChild(firstBtn);
            if (startPage > 2) {
                const ellipsis = document.createElement('span');
                ellipsis.textContent = '...';
                ellipsis.className = 'pag-ellipsis';
                pagContainer.appendChild(ellipsis);
            }
        }

        for (let i = startPage; i <= endPage; i++) {
            const btn = document.createElement('button');
            btn.className = `pag-btn ${i === currentPage ? 'active' : ''}`;
            btn.textContent = i;
            btn.onclick = () => { 
                currentPage = i; 
                renderProducts(); 
                document.getElementById('arma-tu-kit')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            };
            pagContainer.appendChild(btn);
        }

        if (endPage < totalPages) {
            if (endPage < totalPages - 1) {
                const ellipsis = document.createElement('span');
                ellipsis.textContent = '...';
                ellipsis.className = 'pag-ellipsis';
                pagContainer.appendChild(ellipsis);
            }
            const lastBtn = document.createElement('button');
            lastBtn.className = 'pag-btn';
            lastBtn.textContent = totalPages;
            lastBtn.onclick = () => { currentPage = totalPages; renderProducts(); document.getElementById('arma-tu-kit')?.scrollIntoView({ behavior: 'smooth', block: 'start' }); };
            pagContainer.appendChild(lastBtn);
        }

        const nextBtn = document.createElement('button');
        nextBtn.className = 'pag-btn';
        nextBtn.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>';
        nextBtn.disabled = currentPage === totalPages;
        nextBtn.onclick = () => { 
            if(currentPage < totalPages) { 
                currentPage++; 
                renderProducts(); 
                document.getElementById('arma-tu-kit')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            } 
        };
        pagContainer.appendChild(nextBtn);
    }

    function renderTotals() {
        const total = getTotal();
        els.count.textContent = String(selected.length);
        els.total.textContent = money.format(total).replace('MXN', '').trim();
        els.cta.disabled = selected.length !== 5;
        if (els.note) els.note.style.display = 'none';

        if (selectedKit) setKit(selectedKit.id);
    }

    function render() {
        renderSlots();
        renderTotals();
        renderProducts();
    }

    document.querySelectorAll('[data-select-kit]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
            const kitId = e.currentTarget.getAttribute('data-select-kit');
            setKit(kitId);
            document.getElementById('arma-tu-kit')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
    });

    function addToCartLogic(callback) {
        els.cta.disabled = true;
        els.cta.textContent = 'Agregando al carrito...';
        
        const bundleId = 'caja_' + Date.now();
        const items = selected.map(p => ({
            id: p.variantId,
            quantity: 1,
            properties: {
                "Kit": "Parte de la caja de regalos",
                "_bundle_id": bundleId
            }
        }));
        
        // Add all items to Shopify cart
        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
        })
        .then(async response => {
            const data = await response.json();
            if (!response.ok || data.status) {
                throw new Error(data.description || data.message || 'Error al conectar con el carrito');
            }
            return data;
        })
        .then(data => {
            if (callback) callback();
            // Success! We can open the custom cart drawer
            els.cta.textContent = '¡Caja Agregada!';
            
            // Open the custom cart drawer using the theme's global function
            if (typeof window.openCart === 'function') {
                window.openCart();
            } else {
                document.dispatchEvent(new CustomEvent('dj:cart:updated', { bubbles: true }));
            }
            
            // Re-enable and reset after a delay
            setTimeout(() => {
                els.cta.disabled = false;
                els.cta.textContent = 'Continuar';
            }, 3000);
        })
        .catch(error => {
            console.error('Error adding to cart:', error);
            els.cta.disabled = false;
            els.cta.textContent = 'Error al agregar';
            alert("⚠️ No pudimos agregar tu caja: \n" + error.message + "\n\nAsegúrate de que los productos sean reales y tengan inventario.");
            if (callback) callback();
        });
    }

    function showConfirmationModal() {
        const overlay = document.createElement('div');
        overlay.className = 'pk-modal-overlay';
        overlay.id = 'pkConfirmModal';
        
        let productsHtml = '';
        selected.forEach(p => {
            productsHtml += `
                <div class="pk-modal-item">
                    <img src="${p.img}" alt="${p.name.replace(/"/g, '&quot;')}">
                    <div>
                        <div class="name">${p.name}</div>
                        <div class="price">${money.format(p.price).replace('MXN', '').trim()}</div>
                    </div>
                </div>
            `;
        });

        overlay.innerHTML = `
            <div class="pk-modal-content">
                <button class="pk-modal-close" aria-label="Cerrar">&times;</button>
                <h2>Confirma tu Caja de Regalos</h2>
                <p>Estás a punto de agregar estos 5 regalos a tu carrito. ¿Deseas continuar?</p>
                <div class="pk-modal-list">
                    ${productsHtml}
                </div>
                <div class="pk-modal-actions">
                    <button class="pk-modal-cancel" type="button">Volver a editar</button>
                    <button class="pk-modal-confirm" type="button">Confirmar y Agregar</button>
                </div>
            </div>
        `;

        document.body.appendChild(overlay);
        document.body.style.overflow = 'hidden';

        const closeModal = () => {
            overlay.remove();
            document.body.style.overflow = '';
        };

        overlay.querySelector('.pk-modal-close').addEventListener('click', closeModal);
        overlay.querySelector('.pk-modal-cancel').addEventListener('click', closeModal);
        
        overlay.querySelector('.pk-modal-confirm').addEventListener('click', () => {
            const btn = overlay.querySelector('.pk-modal-confirm');
            btn.disabled = true;
            btn.textContent = 'Agregando...';
            addToCartLogic(closeModal);
        });
    }

    els.cta.addEventListener('click', () => {
        if (selected.length !== 5) return;
        showConfirmationModal();
    });

    // --- UX EXPERT: Smart Bundle Detection ---
    function checkCartSync() {
        if (isRestoringCart) return;

        fetch(window.Shopify.routes.root + 'cart.js')
            .then(res => res.json())
            .then(currentCart => {
                if (!previousCartState) {
                    previousCartState = currentCart;
                    return;
                }

                const missingItems = [];
                const previousBundleItems = previousCartState.items.filter(item => item.properties && item.properties['_bundle_id']);
                
                previousBundleItems.forEach(prevItem => {
                    const stillExists = currentCart.items.find(currItem => currItem.key === prevItem.key);
                    if (!stillExists) {
                        missingItems.push(prevItem);
                    }
                });

                if (missingItems.length > 0) {
                    const bundleId = missingItems[0].properties['_bundle_id'];
                    isRestoringCart = true;

                    // Mostrar alerta nativa del navegador
                    const userWantsToDeleteAll = confirm('Este producto pertenece a un bundle. ¿Deseas eliminar toda la caja de regalos o mantenerla completa? \n\n[OK] = Eliminar \n[Cancelar] = Mantener');

                    if (userWantsToDeleteAll) {
                        // Eliminar el resto del bundle
                        const updates = {};
                        currentCart.items.forEach(item => {
                            if (item.properties && item.properties['_bundle_id'] === bundleId) {
                                updates[item.key] = 0;
                            }
                        });
                        
                        fetch(window.Shopify.routes.root + 'cart/update.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ updates })
                        }).then(() => {
                            isRestoringCart = false;
                            document.dispatchEvent(new CustomEvent('dj:cart:updated', { bubbles: true }));
                            fetch(window.Shopify.routes.root + 'cart.js').then(r=>r.json()).then(c => previousCartState = c);
                        });
                    } else {
                        // Restaurar el item borrado
                        const itemsToRestore = missingItems.map(item => ({
                            id: item.variant_id,
                            quantity: item.quantity,
                            properties: item.properties
                        }));

                        fetch(window.Shopify.routes.root + 'cart/add.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ items: itemsToRestore })
                        }).then(() => {
                            isRestoringCart = false;
                            document.dispatchEvent(new CustomEvent('dj:cart:updated', { bubbles: true }));
                            fetch(window.Shopify.routes.root + 'cart.js').then(r=>r.json()).then(c => previousCartState = c);
                        });
                    }
                } else {
                    previousCartState = currentCart;
                }
            });
    }

    // Check every time the cart might have changed
    document.addEventListener('dj:cart:updated', () => {
        setTimeout(checkCartSync, 800); // Darle tiempo al drawer de actualizar su propio estado
    });
    
    render();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initKitPinatas);
} else {
    initKitPinatas();
}
